<template>
    <v-container fill-height>
        <v-card height="100%" width="100%" class="py-3 shadow">
            <v-layout column fill-height>
                <v-flex grow class="layout column" align-center justify-center>
                    <v-flex shrink class="text-xs-center">
                        <h1 class="display-1 mb-3">{{ $store.state.story.title }}</h1>

                        <div class="title mb-5">By {{ $store.state.author.pen_name || $store.state.author.name}}</div>
                        <v-btn outline to="/1">
                            <v-icon class="mr-2">fa fa-book-reader</v-icon>
                            Start Reading
                        </v-btn>
                        <br>
                        <v-btn outline v-if="$store.state.preview.options.has_narrations" @click="$bus.$emit('playFirstChapter')">
                            <v-icon class="mr-2">fa fa-microphone-alt</v-icon>
                            Play Audio
                        </v-btn>

                        <p class="body-2 pa-3 mt-3" style="max-width: 400px;" v-if="$store.state.preview.options.has_narrations && !audioReady">
                            Audio generations are not yet ready. Please try refreshing the page in a couple minutes
                        </p>
                    </v-flex>
                </v-flex>
                <v-flex shrink>
                    <plot-factory-branding></plot-factory-branding>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            audioReady: true,
        }
    },
    mounted() {
        this.$store.state.preview.snapshot.forEach((section) => {
            if (!section.mp3_url) {
                this.audioReady = false
            }
        })
    },
}
</script>
